import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { StandingsTable } from "@/components/StandingsTable";
import { KOBracket } from "@/components/KOBracket";
import { WM_GROUPS } from "@/lib/constants";
import type { Game } from "@/lib/standings";
import { Trophy } from "lucide-react";
import { normalizeGameToSnake } from "@/api/normalize";

const TABS = [
  { key: "tables", label: "Tabellen" },
  { key: "bracket", label: "KO-Phase" },
] as const;

export default function KOPhase() {
  const [games, setGames] = useState<Game[]>([]);
  const [tab, setTab] = useState<typeof TABS[number]["key"]>("tables");

  useEffect(() => {
    document.title = "Tabellen – Englputzeder Tippspiel";
    api.games.list().then((rows) => setGames((rows as any[]).map(normalizeGameToSnake) as Game[]));
  }, []);

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display font-extrabold text-3xl flex items-center gap-2">
          <Trophy className="h-7 w-7 text-primary" /> Tabellen
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Tabellen aller Gruppen und das visuelle Bracket vom Sechzehntelfinale bis zum Finale.
        </p>
      </div>

      <div className="bg-card rounded-pill p-1 flex shadow-card">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex-1 text-sm font-bold py-2 rounded-pill tap transition ${
              tab === t.key ? "bg-primary text-primary-foreground" : "text-muted-foreground"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "tables" && (
        <>
          <div className="grid gap-3 md:grid-cols-2">
            {WM_GROUPS.map((label) => (
              <StandingsTable key={label} games={games} label={label} />
            ))}
          </div>
          <div className="bg-card rounded-lg p-3 text-[11px] text-muted-foreground border border-border">
            <span className="inline-block h-2 w-2 rounded-sm bg-emerald-500 mr-1 align-middle" />
            Qualifiziert (Top&nbsp;2) · Punkte → Tordifferenz → erzielte Tore → direkter Vergleich.
          </div>
        </>
      )}

      {tab === "bracket" && (
        <>
          <KOBracket games={games} />
          <div className="bg-card rounded-lg p-3 text-[11px] text-muted-foreground border border-border space-y-1">
            <div>❓ &nbsp;Platzhalter, solange die Paarung noch nicht feststeht (nicht tippbar)</div>
            <div>
              <span className="font-extrabold text-foreground">Fett</span> = Sieger ·{" "}
              <span className="text-primary font-bold">● LIVE</span> = läuft gerade ·{" "}
              Karte antippen → Spiel öffnen, tippen &amp; Ergebnis ansehen
            </div>
          </div>
        </>
      )}
    </div>
  );
}
